import { scrollToElem } from '../../../../../Common/Resources/src_front/js/helper-functions/scrollToElem';

export function FeaturesMenu() {
    // VARS
    const $this = this;
    $this.featuresMenu = document.querySelector('[data-features-menu]');
    if (!$this.featuresMenu) return;
    const featuresMenuToggle = $this.featuresMenu.querySelector('[data-features-menu-toggle]');
    const featuresBlocks = document.querySelector('[data-features-blocks]');
    const blocks = document.querySelectorAll('[data-anchor-block]');
    const menuButtons = document.querySelectorAll('[data-button-scroll-anchor]');
    const openClass = '--open';
    const activeClass = '--active';

    // INITS
    highlightMenuItem();

    // LISTENERS
    featuresMenuToggle.addEventListener('click', handleOnClickMenuToggle);

    menuButtons.forEach((menuButton) => {
        menuButton.addEventListener('click', handleOnClickMenuItem);
    });

    window.addEventListener('scroll', handleOnScrollPage);

    // HANDLERS
    function handleOnClickMenuToggle() {
        toggleMenu();
    }

    function handleOnScrollPage() {
        highlightMenuItem();
    }

    function handleOnClickMenuItem() {
        if (window.innerWidth < 1280) {
            scrollToElem(this.getAttribute('data-button-scroll-anchor'));
        } else {
            const top = featuresBlocks.offsetTop;
            const blockHeight = featuresBlocks.getBoundingClientRect().height / blocks.length;
            const halfBlockHeight = blockHeight / 2;
            const index = +this.getAttribute('data-button-scroll');

            window.scrollTo({
                top: top + blockHeight * index - halfBlockHeight - 100,
                behavior: 'smooth',
            });
        }

        $this.closeMenu();
    }

    // FUNCTIONS
    function openMenu() {
        $this.featuresMenu.classList.add(openClass);
    }

    $this.closeMenu = () => {
        $this.featuresMenu.classList.remove(openClass);
    };

    function toggleMenu() {
        $this.featuresMenu.classList.contains(openClass) ? $this.closeMenu() : openMenu();
    }

    function highlightMenuItem() {
        const blockHeight = featuresBlocks.getBoundingClientRect().height / blocks.length;
        const halfBlockHeight = blockHeight / 2 - 100;
        const topOffset = featuresBlocks.getBoundingClientRect().top;
        const index = Math.max(Math.floor((-topOffset + halfBlockHeight) / blockHeight), 0);

        if (index < blocks.length) {
            setActiveMenu(index);
            changeActiveBlock(index);
            changeBackgroundBlock(index);
        } else if (index === blocks.length) {
            setActiveMenu(index - 1);
            changeActiveBlock(index - 1);
            changeBackgroundBlock(index - 1);
        }
    }

    function setActiveMenu(index) {
        menuButtons.forEach((btn) => {
            btn.classList.remove(activeClass);
        });

        menuButtons[index].classList.add(activeClass);
    }

    function changeActiveBlock(index) {
        blocks.forEach((block) => {
            block.classList.remove(activeClass);
        });

        blocks[index].classList.add(activeClass);
    }

    function changeBackgroundBlock(index) {
        const classes = [
            '--blue-charcoal',
            '--white',
            '--whisper',
            '--blue-charcoal',
            '--white',
            '--whisper',
            '--blue-charcoal',
            '--white',
            '--whisper',
        ];

        for (let i = 0; i < classes.length; i++) {
            if (i !== index) {
                featuresBlocks.classList.remove(classes[i]);
            }
        }

        featuresBlocks.classList.add(classes[index]);
    }
}
